import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default React.memo(NewsTalkItem);

function NewsTalkItem(props) {
  const { t } = useTranslation();
  const { item, openNewsChatRoom, actionSubscribe } = props;
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const logo =
    item.cnmPicMain !== ""
      ? item.cnmPicMain.split("?")[0]
      : "https://freiscop.gbts.co.kr/images/user_pic-50x50.png";

  return (
    <div className="d-flex flex-row justify-content-start align-items-center cursor_pointer cursor_pointer_bg_light rounded px-2 py-1 mb-2">
      <div
        className="flex-fill d-flex flex-row justify-content-start align-items-center"
        onClick={() => openNewsChatRoom(item)}
      >
        <div className="overflow-hidden mr-2">
          <div
            className="border"
            style={{
              borderRadius: "45%",
              width: 46,
              height: 46,
              background: `url(${logo}) #fff 50% 50%/contain no-repeat`,
            }}
          />
        </div>
        <div className="flex-fill">
          <div className="d-flex flex-row justify-content-between align-items-center position-relative">
            <p className="flex-fill text-truncate font-weight-bold">
              {item.cnmName}
            </p>
          </div>
          <p className="font-size-08">{item.cnmCompNM}</p>
        </div>
      </div>
      {item.cnmType === "3" && (
        <div className="align-self-start position-relative">
          <i
            className="fa-solid fa-ellipsis-vertical px-1 cursor_pointer"
            onClick={() => setIsOpenMenu(true)}
          />
          {isOpenMenu && (
            <>
              <div
                className="position-absolute bg-white rounded shadow-sm overflow-hidden"
                style={{ minWidth: 120, zIndex: 4, top: 0, right: 0 }}
              >
                <p
                  className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                  onClick={() => actionSubscribe(item)}
                >
                  {t("logiTalk.favList.newsTalk.unsubscribe")}
                </p>
              </div>
              <div
                className="vw-100 vh-100 position-fixed cursor_pointer"
                style={{
                  top: 0,
                  left: 0,
                  zIndex: 3,
                  background: "rgba(0,0,0,0.1)",
                }}
                onClick={() => setIsOpenMenu(false)}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}
